import Vue from 'vue'
/*
 * directive
 */
Vue.directive('bg-cover', function (el, binding) {
  el.style.cssText += `
    ;
    background: url('${binding.value}') center center no-repeat;
    -webkit-background-size: cover;
    background-size: cover;
  `
})

Vue.directive('bg-contain', function (el, binding) {
  el.style.cssText += `
    ;
    background: url('${binding.value}') center center no-repeat;
    -webkit-background-size: contain;
    background-size: contain;
  `
})

// Vue.filter('date-filter', function (value) {
//   return formatDate(value)
// })
